<ng-container #chatContainer></ng-container>